import React, { useState } from "react";
import { Col, Row, Form, Image, Alert } from '@themesberg/react-bootstrap';

export const AddBannerForm = (props) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState('');

  const onImageChange = (evt) => {
    const file = evt.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        setImageError('Chỉ chấp nhận file ảnh định dạng JPEG, PNG, GIF, hoặc WebP');
        setImagePreview(null);
        props.setImage(null);
        return;
      }

      // Validate file size (10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        setImageError('Kích thước file không được vượt quá 10MB');
        setImagePreview(null);
        props.setImage(null);
        return;
      }

      setImageError('');
      
      // Create preview
      const reader = new FileReader();
      reader.onload = function(e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // Set the actual file object for upload
      props.setImage(file);
    }
  }

  return (
    <Form>
      <Row>
        <Col md={12} className="mb-2">
          <Form.Group id="bannerImage">
            <Form.Label>Hình ảnh banner</Form.Label>
            <Form.Control 
              required 
              type="file" 
              accept="image/*"
              onChange={onImageChange} 
            />
            <Form.Text className="text-muted">
              Chấp nhận file ảnh định dạng JPEG, PNG, GIF, WebP. Tối đa 10MB.
            </Form.Text>
          </Form.Group>
          
          {imageError && (
            <Alert variant="danger" className="mt-2">
              {imageError}
            </Alert>
          )}
          
          {imagePreview && (
            <div className="mt-3">
              <Form.Label>Xem trước:</Form.Label>
              <div>
                <Image 
                  src={imagePreview} 
                  alt="Preview" 
                  style={{ maxWidth: '300px', maxHeight: '200px', objectFit: 'contain' }}
                  thumbnail
                />
              </div>
            </div>
          )}
        </Col>
      </Row>
    </Form>
  );
};